const general = {
    placeholder: 'Placeholder',
    submit: 'Gửi',
    skip: 'Bỏ qua',
    next: 'Tiếp theo',
    back: 'Quay lại',
    retry: 'Thử lại',
    done: 'Xong',
    search: 'Tìm kiếm',
    search_placeholder: 'Tìm kiếm',
    clear_result: 'Xóa kết quả',
    today: 'Hôm nay',
    clear: 'Xóa',
    save: 'Lưu',
    save_changes: 'Lưu thay đổi',
    saved: 'Đã lưu',
    discard: 'Hủy bỏ',
    download: 'Tải xuống',
    loading: 'Đang tải...',
    redirecting: 'Đang chuyển hướng...',
    add: 'Thêm',
    added: 'Đã thêm',
    cancel: 'Hủy',
    confirm: 'Xác nhận',
    check_out: 'Xem thử',
    create: 'Tạo',
    set_up: 'Thiết lập',
    customize: 'Tùy chỉnh',
    enable: 'Bật',
    disable: 'Tắt',
    reminder: 'Nhắc nhở',
    edit: 'Sửa',
    delete: 'Xóa',
    deleted: 'Đã xóa',
    activate: 'Kích hoạt',
    deactivate: 'Hủy kích hoạt',
    more_options: 'THÊM TÙY CHỌN',
    close: 'Đóng',
    copy: 'Sao chép',
    copying: 'Đang sao chép',
    copied: 'Đã sao chép',
    required: 'Bắt buộc',
    add_another: 'Thêm cái khác',
    create_another: 'Tạo cái khác',
    deletion_confirmation: 'Bạn có chắc chắn muốn xóa {{title}} này không?',
    settings_nav: 'Cài đặt',
    unsaved_changes_warning: 'Bạn đã thực hiện một số thay đổi. Bạn có chắc chắn muốn rời khỏi trang này?',
    leave_page: 'Rời khỏi trang',
    stay_on_page: 'Ở lại trang',
    type_to_search: 'Nhập để tìm kiếm',
    got_it: 'Đã hiểu',
    continue: 'Tiếp tục',
    page_info: '{{min, number}}-{{max, number}} trong {{total, number}}',
    learn_more: 'Tìm hiểu thêm',
    tab_error: '{{count, number}} lỗi',
    tab_error_other: '{{count, number}} lỗi',
    skip_for_now: 'Bỏ qua lúc này',
    remove: 'Xóa bỏ',
    visit: 'Truy cập',
    join: 'Tham gia',
    try_now: 'Thử ngay',
    multiple_form_field: '(Nhiều giá trị)',
    demo: 'Demo',
    unnamed: 'Chưa đặt tên',
    view: 'Xem',
    open: 'Mở',
    hide: 'Ẩn',
    unknown_error: 'Lỗi không xác định, vui lòng thử lại sau.',
    select: 'Chọn',
    contact_us_action: 'Liên hệ với chúng tôi',
    description: 'Mô tả',
    name: 'Tên',
    add_field: 'Thêm {{field}}',
    create_field: 'Tạo {{field}}',
    edit_field: 'Sửa {{field}}',
    delete_field: 'Xóa {{field}}',
    coming_soon: 'Sắp ra mắt',
    or: 'Hoặc',
    reset: 'Đặt lại',
    generate: 'Tạo',
    manage: 'Quản lý',
    live_preview: 'Xem trước trực tiếp',
};
export default Object.freeze(general);
